import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingAddress } from 'src/app/interfaces/billing-address';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { BillingService } from 'src/app/services/billing.service';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-r-ach-card-payment',
    templateUrl: './r-ach-card-payment.component.html',
    styleUrls: ['./r-ach-card-payment.component.scss'],
    standalone: false
})
export class RAchCardPaymentComponent {
     showBilling: boolean = false;
     loadingPayment: boolean = false;
     iframeSrc: SafeResourceUrl | null =  null;

     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService, public translatorService:TranslatorService,
          public billingService: BillingService,
          public sanitizer: DomSanitizer, private _router:  Router) {
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }
     unloadMessage = function () {
          return 'You have created an account but not set up billing. Are you sure you wish to exit?';
     }

     ngOnInit(): void {
          const component = this;
          window.removeEventListener('message', function (e) { });
          window.addEventListener('message', function (e) {
               if (e.data === "Cancel" && component.enrollmentService.billingState != "NA") {
                    component.generalService.pageLogging("23.ach/card", null, "", "", "Add Payment Canceled:" + component.enrollmentService.customerId);
                    component.cancelPayment();
               } else if (e.data === "PaymentAccountAdded") {
                    if (component.enrollmentService.billingState != "NA") {
                         component.generalService.pageLogging("ach/card", null, "", "", "Payment Type Added:" + component.enrollmentService.customerId);
                         component.moveToAllDone(true);
                    } else {
                         component.generalService.pageLogging("ach/card", null, "", "Error adding Payment:" + component.enrollmentService.customerId, "");
                    }
               } else if (e.data === "UpdateComplete") {
                    component.enrollmentService.billingState = "NA";
                    component.billingService.walletURL = "";
                    component.generalService.pageLogging("ach/card", null, "", "", "Payment Type Updated:" + component.enrollmentService.customerId);
                    component.showBilling = false
               } else if (e.data === "Timeout" || e.data === "Error") {
                    component.generalService.pageLogging("ach/card", null, "", "Error adding Payment:" + component.enrollmentService.customerId, e.data);
                    component.showBillingError(component);
               } else if (e.data === "AddMode" && component.enrollmentService.billingState !== "AddMode") {
                    component.enrollmentService.billingState = "AddMode";
               };
          });
          document.getElementById('set-up-auto-pay')?.focus();
          window.onbeforeunload = this.unloadMessage;

          setTimeout(() => this.scrollToTop(), 500);
     }

     cancelPayment() {
          this.enrollmentService.billingState = "NA";
          this.billingService.walletURL = '';
          this.showBilling = false;
          this._router.navigateByUrl('/signup/24');
          setTimeout(() => this.scrollToTop(), 500);
      }
  
      moveToAllDone(value: any) {
          this.billingService.walletURL = "";
          this.enrollmentService.billingState = "NA";
          if (value === true) {
               this.billingService.updateDefaultBilling(this.enrollmentService.customerId).subscribe((info:any) => {                
                    this.generalService.pageLogging("ach/card",null,"","","Set Default Payment:" + this.enrollmentService.customerId);
              })
              this._router.navigateByUrl('/signup/24');
          } else {
              this.showBillingError(null);
          }
      }
  
      showBillingError(component: any) {
          this._router.navigateByUrl('/signup/23');
      };
  
      showBillingBox() {
          this.loadingPayment = true;
          const billingAddress: BillingAddress = {
               Address1:this.enrollmentService!.newCustomer!.address!.addressLine1,
               Address2:this.enrollmentService!.newCustomer!.address!.addressLine2,
               City:this.enrollmentService.newCustomer!.city!,
               State:this.enrollmentService.newCustomer!.state!,
               PostalCode:this.enrollmentService.newCustomer!.zip!,
               Country:this.enrollmentService!.newCustomer!.address!.country!
          }

          const cdbInfo = this.billingService.createCDBBillingAccount(this.enrollmentService.customerId,
               this.enrollmentService.billingEmail,
               billingAddress,
               this.translatorService.activeLanguage
               )
          cdbInfo.subscribe((v: any) => this.cdbInfo(v));
      }
  
      cdbInfo(response: any) {
          if (response === '') {
               this._router.navigateByUrl('/signup/25');
          } else {
              this.setIframeInfo(response)
          }
      }
  
      setIframeInfo(data: any) {
          this.billingService.walletURL = data;
          this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(data);
          this.enrollmentService.billingState = "get";
          this.showBilling = true;
          this.loadingPayment = false;
      }
  
      setupChecking() {
          setTimeout(() => this.scrollToTop(), 500);
          this._router.navigateByUrl('/signup/24');
      }
   
      scrollToTop() {
          window.scrollTo(0, 0);
      }
  
      customizeSuccessMessage() {
          let translatedText: string = this.generalService.getTranslation('billing_1')
          if (translatedText === undefined) {
              translatedText = this.generalService.getTranslation('billing_1');
          }
          translatedText = translatedText.replace('##email##', this.enrollmentService.PrimaryContactEmail);
          return translatedText;
      }

     ngOnDestroy() {
          this.enrollmentService.clearLocal();
          window.onbeforeunload = null;
     }

}
